import classNames from 'classnames';
import { CreateInitiative } from './CreateInitiative';
import { getInitiativeRoute } from '@lib/routes';
import { Initiative } from '@sonar-software/sonar-core';
import { PopoverSelector } from '@ui/PopoverSelector';
import { useInitiatives } from '@hooks';
import { FULL_ROUTES, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { PropsWithChildren } from 'react';

export interface InitiativeSelectorProps {
	className?: string;
	onDeselect: (initiative: Initiative) => void;
	onOpenChange?: (visible: boolean) => void;
	onSelect: (initiative: Initiative) => void;
	selectedIds?: Array<number>;
	singleSelect?: boolean;
	trigger?: 'hover' | 'click';
}

export const InitiativeSelector: React.FC<PropsWithChildren<InitiativeSelectorProps>> = ({
	children,
	className,
	onDeselect,
	onOpenChange,
	onSelect,
	selectedIds = [],
	singleSelect,
	trigger = 'hover'
}) => {
	const { data, request } = useInitiatives();

	return (
		<PopoverSelector
			className={ classNames('initiative-picker', className) }
			footer={
				<CreateInitiative
					onFinish={ (response) =>
						onSelect({
							id: response.initiativeId,
							title: response.initiativeTitle
						} as Initiative) }
					source='card' />
			}
			itemRender={ ({ title }) => title }
			listItems={ data.results }
			manageRoute={ FULL_ROUTES.INITIATIVES }
			onDeselect={ onDeselect }
			onOpen={ (initiativeId) => {
				window.open(`${window.location.origin}${getInitiativeRoute(initiativeId)}`, '_blank');
			} }
			onOpenChange={ onOpenChange }
			onSearch={ (value) => {
				request({
					...useInitiatives.defaultRequest,
					title: value
				});
			} }
			onSelect={ onSelect }
			placeholder={ PLACEHOLDERS_COPY.SEARCH_INITIATIVES }
			selectedIds={ selectedIds }
			singleSelect={ singleSelect }
			trigger={ trigger }>
			{ children }
		</PopoverSelector>
	);
};
